module.exports = __webpack_public_path__ + "img/c9f9cf0.jpg";